import { ref, watch } from 'vue';

const storageName = 'theme';

const getTheme = (): 'dark' | 'light' => {
  const theme = localStorage.getItem(storageName);

  if (theme === 'dark' || theme === 'light') {
    return theme;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const setTheme = (theme: 'dark' | 'light') => {
  document.body.style.setProperty('--theme', theme);
  document.body.classList.remove('light', 'dark');
  document.body.classList.add(theme);
  localStorage.setItem(storageName, theme);
};

const isLight = ref<boolean>(getTheme() === 'light');

setTheme(isLight.value ? 'light' : 'dark');

watch(isLight, (newIsLight) => {
  setTheme(newIsLight ? 'light' : 'dark');
});

export const useTheme = () => {
  return {
    isLight,
  };
};
